import axios from "axios";
import { URL_BASE, URL_USER } from "../../utils/urls";

const BASE = URL_BASE + "api/auditor-checklist";

// ============ Login ============

export async function postAuditorLogin({ email, password }) {
  return axios.post(
    URL_USER + "login",
    { username: email, password, company: "" },
    { headers: { "Content-Type": "application/x-www-form-urlencoded" } }
  );
}

// ============ Portal del auditor ============

export async function getAuditorInfo() {
  const { data } = await axios.get(`${BASE}/portal/me`);
  return data;
}

export async function getMisAsignaciones({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/mis-asignaciones`, { signal });
  return data;
}

export async function getAsignacionDetalle(id, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/asignaciones/${id}`, { signal });
  return data;
}

export async function guardarProgreso(id, respuestas) {
  const { data } = await axios.put(`${BASE}/portal/asignaciones/${id}/guardar`, { respuestas });
  return data;
}

export async function enviarAsignacion(id, respuestas) {
  const { data } = await axios.post(`${BASE}/portal/asignaciones/${id}/enviar`, { respuestas });
  return data;
}

export async function subirFoto(asignacionId, file, respuestaId, descripcion) {
  const formData = new FormData();
  formData.append("file", file);
  if (respuestaId) formData.append("respuesta_id", respuestaId);
  if (descripcion) formData.append("descripcion", descripcion);
  const { data } = await axios.post(`${BASE}/portal/asignaciones/${asignacionId}/fotos`, formData);
  return data;
}

export async function eliminarFoto(fotoId) {
  await axios.delete(`${BASE}/portal/fotos/${fotoId}`);
}

export async function listarFotos(asignacionId, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/asignaciones/${asignacionId}/fotos`, { signal });
  return data;
}

// ============ Admin: Auditores ============

export async function getAuditores({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/auditores`, { signal });
  return data;
}

export async function createAuditor(body) {
  const { data } = await axios.post(`${BASE}/auditores`, body);
  return data;
}

export async function updateAuditor(body) {
  await axios.put(`${BASE}/auditores`, body);
}

export async function deleteAuditor(id) {
  await axios.delete(`${BASE}/auditores`, { params: { id } });
}

// ============ Admin: Checklists ============

export async function getChecklists(params = {}, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/checklists`, { params, signal });
  return data;
}

export async function getChecklistsActivos({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/checklists/activos`, { signal });
  return data;
}

export async function getChecklistById(id, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/checklists/${id}`, { signal });
  return data;
}

export async function createChecklist(body) {
  const { data } = await axios.post(`${BASE}/checklists`, body);
  return data;
}

export async function updateChecklist(id, body) {
  const { data } = await axios.put(`${BASE}/checklists/${id}`, body);
  return data;
}

export async function deleteChecklist(id) {
  await axios.delete(`${BASE}/checklists/${id}`);
}

// ============ Admin: Asignaciones ============

export async function getAsignaciones(params = {}, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/asignaciones`, { params, signal });
  return data;
}

export async function getAsignacionById(id, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/asignaciones/${id}`, { signal });
  return data;
}

export async function createAsignacion(body) {
  const { data } = await axios.post(`${BASE}/asignaciones`, body);
  return data;
}

export async function revisarAsignacion(id, body) {
  const { data } = await axios.post(`${BASE}/asignaciones/${id}/revisar`, body);
  return data;
}

export async function deleteAsignacion(id) {
  await axios.delete(`${BASE}/asignaciones/${id}`);
}

export async function actualizarAsignacion(id, body) {
  await axios.put(`${BASE}/asignaciones/${id}`, body);
}

export async function guardarProgresoAdmin(id, respuestas) {
  const { data } = await axios.put(`${BASE}/asignaciones/${id}/guardar`, { respuestas });
  return data;
}

export async function enviarAsignacionAdmin(id, respuestas) {
  const { data } = await axios.post(`${BASE}/asignaciones/${id}/enviar`, { respuestas });
  return data;
}

export async function subirFotoAdmin(asignacionId, file, respuestaId, descripcion) {
  const formData = new FormData();
  formData.append("file", file);
  if (respuestaId) formData.append("respuesta_id", respuestaId);
  if (descripcion) formData.append("descripcion", descripcion);
  const { data } = await axios.post(`${BASE}/asignaciones/${asignacionId}/fotos`, formData);
  return data;
}

export async function eliminarFotoAdmin(fotoId) {
  await axios.delete(`${BASE}/fotos/${fotoId}`);
}

// ============ Admin: Sesiones (iniciar como admin) ============

export async function getObjetivosAdmin({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/sesiones/objetivos-disponibles`, { signal });
  return data;
}

export async function getEmpleadosPresentesAdmin(date, objectiveId) {
  const { data } = await axios.get(`${BASE}/sesiones/empleados-presentes`, {
    params: { date, objectiveId },
  });
  return data;
}

export async function iniciarSesionAdmin(body) {
  const { data } = await axios.post(`${BASE}/sesiones/iniciar`, body);
  return data;
}

export async function guardarProgresoSesionAdmin(id, respuestas) {
  const { data } = await axios.put(`${BASE}/sesiones/${id}/guardar`, { respuestas });
  return data;
}

export async function enviarSesionAdmin(id, respuestas) {
  const { data } = await axios.post(`${BASE}/sesiones/${id}/enviar`, { respuestas });
  return data;
}

export async function subirFotoSesionAdmin(sesionId, file, respuestaId, descripcion, checklistItemId) {
  const formData = new FormData();
  formData.append("file", file);
  if (respuestaId) formData.append("respuesta_id", respuestaId);
  // El item va siempre: si la respuesta todavia no se guardo, es lo unico que ata la foto a su pregunta
  if (checklistItemId) formData.append("checklist_item_id", checklistItemId);
  if (descripcion) formData.append("descripcion", descripcion);
  const { data } = await axios.post(`${BASE}/sesiones/${sesionId}/fotos`, formData);
  return data;
}

export async function eliminarFotoSesionAdmin(fotoId) {
  await axios.delete(`${BASE}/sesiones/fotos/${fotoId}`);
}

export async function exportarSesionPdf(id) {
  const { data } = await axios.get(`${BASE}/sesiones/${id}/exportar-pdf`, {
    responseType: "blob",
  });
  return data;
}

// ============ Sesiones - Portal Auditor ============

export async function getChecklistsDisponibles({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/sesiones/checklists-disponibles`, { signal });
  return data;
}

export async function getObjetivosDisponibles({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/sesiones/objetivos-disponibles`, { signal });
  return data;
}

export async function iniciarSesion(body) {
  const { data } = await axios.post(`${BASE}/portal/sesiones/iniciar`, body);
  return data;
}

export async function getEmpleadosPresentesAuditor(date, objectiveId) {
  const { data } = await axios.get(`${BASE}/portal/sesiones/empleados-presentes`, {
    params: { date, objectiveId },
  });
  return data;
}

export async function getMisSesiones({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/sesiones`, { signal });
  return data;
}

export async function getSesionDetalle(id, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/sesiones/${id}`, { signal });
  return data;
}

// Solo mientras la sesion esta EN_PROGRESO: por si el auditor se equivoco al iniciarla. Una
// sesion ya COMPLETADA no se puede borrar desde el portal (el backend responde 400).
export async function eliminarSesion(id) {
  await axios.delete(`${BASE}/portal/sesiones/${id}`);
}

export async function guardarProgresoSesion(id, respuestas) {
  const { data } = await axios.put(`${BASE}/portal/sesiones/${id}/guardar`, { respuestas });
  return data;
}

export async function enviarSesion(id, respuestas) {
  const { data } = await axios.post(`${BASE}/portal/sesiones/${id}/enviar`, { respuestas });
  return data;
}

export async function subirFotoSesion(sesionId, file, respuestaId, descripcion, checklistItemId) {
  const formData = new FormData();
  formData.append("file", file);
  if (respuestaId) formData.append("respuesta_id", respuestaId);
  // El item va siempre: si la respuesta todavia no se guardo, es lo unico que ata la foto a su pregunta
  if (checklistItemId) formData.append("checklist_item_id", checklistItemId);
  if (descripcion) formData.append("descripcion", descripcion);
  const { data } = await axios.post(`${BASE}/portal/sesiones/${sesionId}/fotos`, formData);
  return data;
}

export async function eliminarFotoSesion(fotoId) {
  await axios.delete(`${BASE}/portal/sesiones/fotos/${fotoId}`);
}

export async function listarFotosSesion(sesionId, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/sesiones/${sesionId}/fotos`, { signal });
  return data;
}

// ============ Sesiones - Admin ============

export async function getSesiones(params = {}, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/sesiones`, { params, signal });
  return data;
}

export async function getResumenSesiones(params = {}, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/sesiones/resumen`, { params, signal });
  return data;
}

export async function getSesionById(id, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/sesiones/${id}`, { signal });
  return data;
}

export async function revisarSesion(id, body) {
  const { data } = await axios.post(`${BASE}/sesiones/${id}/revisar`, body);
  return data;
}

export async function deleteSesion(id) {
  await axios.delete(`${BASE}/sesiones/${id}`);
}

// ============ Employee Portal ============

export async function tieneAsignacionesEmpleado({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/empleado-portal/tiene-asignaciones`, { signal });
  return data.tiene;
}

export async function getMisAsignacionesEmpleado({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/empleado-portal/mis-asignaciones`, { signal });
  return data;
}

export async function getAsignacionEmpleado(id, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/empleado-portal/asignaciones/${id}`, { signal });
  return data;
}

export async function guardarProgresoEmpleado(id, respuestas) {
  const { data } = await axios.put(`${BASE}/empleado-portal/asignaciones/${id}/guardar`, { respuestas });
  return data;
}

export async function enviarAsignacionEmpleado(id, respuestas) {
  const { data } = await axios.post(`${BASE}/empleado-portal/asignaciones/${id}/enviar`, { respuestas });
  return data;
}

export async function subirFotoEmpleado(asignacionId, file, respuestaId, descripcion) {
  const formData = new FormData();
  formData.append("file", file);
  if (respuestaId) formData.append("respuesta_id", respuestaId);
  if (descripcion) formData.append("descripcion", descripcion);
  const { data } = await axios.post(`${BASE}/empleado-portal/asignaciones/${asignacionId}/fotos`, formData);
  return data;
}

export async function eliminarFotoEmpleado(fotoId) {
  await axios.delete(`${BASE}/empleado-portal/fotos/${fotoId}`);
}

export async function listarFotosEmpleado(asignacionId, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/empleado-portal/asignaciones/${asignacionId}/fotos`, { signal });
  return data;
}

// ============ Admin: Planificacion ============

export async function getAcPlanificaciones(params = {}, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/planificacion`, { params, signal });
  return data;
}

export async function crearAcPlanificacionBulk(body) {
  const { data } = await axios.post(`${BASE}/planificacion`, body);
  return data;
}

export async function actualizarAcPlanificacion(id, body) {
  const { data } = await axios.put(`${BASE}/planificacion/${id}`, body);
  return data;
}

export async function eliminarAcPlanificacion(id) {
  await axios.delete(`${BASE}/planificacion/${id}`);
}

export async function toggleAcPlanificacion(id) {
  await axios.patch(`${BASE}/planificacion/${id}/toggle`);
}

export async function getAcCumplimiento(params = {}, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/planificacion/cumplimiento`, { params, signal });
  return data;
}

export async function getAcCumplimientoMensual(year, month, auditorId, { signal } = {}) {
  const params = { year, month };
  if (auditorId) params.auditorId = auditorId;
  const { data } = await axios.get(`${BASE}/planificacion/cumplimiento/mensual`, { params, signal });
  return data;
}

export async function getAcAlertas(params = {}, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/planificacion/alertas`, { params, signal });
  return data;
}

export async function marcarAcAlertaLeida(id) {
  await axios.patch(`${BASE}/planificacion/alertas/${id}/leida`);
}

export async function resolverAcAlerta(id, notas) {
  await axios.patch(`${BASE}/planificacion/alertas/${id}/resolver`, { notas });
}

export async function contarAcAlertasPendientes({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/planificacion/alertas/count`, { signal });
  return data;
}

// ============ Portal Auditor: Actas de Visita / Capacitacion ============

export async function getMisActas(page = 0, size = 50, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/actas`, { params: { page, size }, signal });
  return data;
}

export async function getActaPortal(id, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/actas/${id}`, { signal });
  return data;
}

export async function crearActaPortal(body) {
  const { data } = await axios.post(`${BASE}/portal/actas`, body);
  return data;
}

export async function actualizarActaPortal(id, body) {
  const { data } = await axios.put(`${BASE}/portal/actas/${id}`, body);
  return data;
}

export async function firmarActaPortal(id, firmas) {
  const { data } = await axios.put(`${BASE}/portal/actas/${id}/firmar`, firmas);
  return data;
}

export async function eliminarActaPortal(id) {
  await axios.delete(`${BASE}/portal/actas/${id}`);
}

export async function exportarActaPortalPDF(id) {
  const { data } = await axios.get(`${BASE}/portal/actas/${id}/exportar-pdf`, { responseType: "blob" });
  return data;
}

// Constancia de capacitacion (formulario PG.09-F11). Solo tiene sentido en actas
// con es_capacitacion = true; el acta de visita normal sigue usando exportar-pdf.
// Estilo portal: devuelve el Blob ya desempaquetado.
export async function descargarConstanciaActaPortal(id) {
  const { data } = await axios.get(`${BASE}/portal/actas/${id}/constancia-pdf`, { responseType: "blob" });
  return data;
}

export async function subirAdjuntoActaPortal(actaId, file, descripcion) {
  const formData = new FormData();
  formData.append("file", file);
  if (descripcion) formData.append("descripcion", descripcion);
  const { data } = await axios.post(`${BASE}/portal/actas/${actaId}/adjuntos`, formData);
  return data;
}

export async function getAdjuntosActaPortal(actaId, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/actas/${actaId}/adjuntos`, { signal });
  return data;
}

export async function eliminarAdjuntoActaPortal(adjuntoId) {
  await axios.delete(`${BASE}/portal/actas/adjuntos/${adjuntoId}`);
}

// Bytes de un adjunto del acta, del lado portal: es la UNICA forma de abrir los privados
// (los de las investigaciones, que no tienen s3_url). Estilo admin: devuelve la respuesta
// axios completa, el Blob es res.data (el tipo viene en res.headers["content-type"]).
export async function descargarAdjuntoActaPortal(adjuntoId) {
  return axios.get(`${BASE}/portal/actas/adjuntos/${adjuntoId}/archivo`, { responseType: "blob" });
}

export async function getObjetivosActaPortal({ signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/actas/objetivos-disponibles`, { signal });
  return data;
}

// Ultima auditoria o acta de ese objetivo (en los ultimos 3 meses; si no hubo, viene todo en
// null). Es solo un aviso: nunca bloquea elegir el objetivo ni guardar. La usan tanto "Iniciar
// Auditoria" como "Nueva acta" del portal.
export async function obtenerUltimaActividadObjetivoPortal(objetivoId, { signal } = {}) {
  const { data } = await axios.get(`${BASE}/portal/actas/objetivo/${objetivoId}/ultima-actividad`, { signal });
  return data;
}

// ============ Admin: Actas de Visita / Capacitacion ============

// filters acepta, todos opcionales y en camelCase como los espera el controller:
// estado, objectiveId, supervisorId, fechaDesde, fechaHasta, tipo (VISITA,
// CAPACITACION o INVESTIGACION; ausente = todo), esCapacitacion (true = solo
// capacitaciones, false = visitas e investigaciones; si viene tipo, gana tipo) y q
// (busca por "contiene", sin distinguir mayusculas, en supervisor, cliente, objetivo
// y motivo).
export async function getAcActasVisita(page = 0, size = 20, filters = {}, { signal } = {}) {
  const params = { page, size, ...filters };
  return axios.get(`${BASE}/actas`, { params, signal });
}

// Contadores del tablero de actas. Los calcula el backend sobre todo el universo
// visible y no sobre la pagina del listado. No recibe estado ni tipo:
// son los filtros que el usuario elige con los chips, asi que los contadores
// tienen que describir el universo sin ellos.
// Estilo admin: devuelve la respuesta axios completa, leer res.data.
export async function getAcActasStats(filters = {}, { signal } = {}) {
  return axios.get(`${BASE}/actas/stats`, { params: filters, signal });
}

export async function getAcActaById(id) {
  return axios.get(`${BASE}/actas/${id}`);
}

export async function crearAcActaVisita(body) {
  return axios.post(`${BASE}/actas`, body);
}

export async function actualizarAcActaVisita(id, body) {
  return axios.put(`${BASE}/actas/${id}`, body);
}

export async function firmarAcActaVisita(id, firmas) {
  return axios.put(`${BASE}/actas/${id}/firmar`, firmas);
}

// Firma opcional de UN presente de la lista (personal presente / asistente), independiente
// de la firma del supervisor y de la del referente del cliente: no cierra el acta.
export async function firmarEmpleadoPresenteAcActa(actaId, empleadoPresenteId, firma) {
  return axios.put(`${BASE}/actas/${actaId}/empleados/${empleadoPresenteId}/firmar`, { firma });
}

export async function eliminarAcActaVisita(id) {
  return axios.delete(`${BASE}/actas/${id}`);
}

export async function exportarAcActaPDF(id) {
  return axios.get(`${BASE}/actas/${id}/exportar-pdf`, { responseType: "blob" });
}

// Ultima auditoria o acta de ese objetivo (en los ultimos 3 meses; si no hubo, viene todo en
// null). Es solo un aviso: nunca bloquea elegir el objetivo ni guardar. La usan tanto "Iniciar
// Auditoria" como "Nueva acta" del admin. Estilo admin: devuelve la respuesta axios completa.
export async function obtenerUltimaActividadObjetivo(objetivoId, { signal } = {}) {
  return axios.get(`${BASE}/actas/objetivo/${objetivoId}/ultima-actividad`, { signal });
}

// OJO con la asimetria de este archivo: las funciones del portal (arriba) devuelven
// `data` ya desempaquetado y las de admin devuelven la respuesta axios COMPLETA.
// En admin hay que leer res.data para quedarse con el Blob, si no el archivo sale
// corrupto sin ningun error visible.
export async function descargarConstanciaAcActa(id) {
  return axios.get(`${BASE}/actas/${id}/constancia-pdf`, { responseType: "blob" });
}

// Observaciones anonimas que dejaron los asistentes desde el QR de la constancia.
// Estilo admin: devuelve la respuesta axios completa, leer res.data.
export async function getObservacionesAcActa(id) {
  return axios.get(`${BASE}/actas/${id}/observaciones`);
}

export async function subirAdjuntoAcActa(actaId, file, descripcion) {
  const formData = new FormData();
  formData.append("file", file);
  if (descripcion) formData.append("descripcion", descripcion);
  return axios.post(`${BASE}/actas/${actaId}/adjuntos`, formData);
}

export async function getAdjuntosAcActa(actaId) {
  return axios.get(`${BASE}/actas/${actaId}/adjuntos`);
}

export async function eliminarAdjuntoAcActa(adjuntoId) {
  return axios.delete(`${BASE}/actas/adjuntos/${adjuntoId}`);
}

// Bytes de un adjunto del acta. Sirve para todos, pero es la UNICA forma de abrir los
// privados (adj.privado: los de las investigaciones, que no tienen s3_url): el backend
// controla que quien pide pueda leer el acta y responde con Cache-Control: no-store.
// Estilo admin: devuelve la respuesta axios completa, el Blob es res.data (el tipo
// viene en res.headers["content-type"]).
export async function descargarAdjuntoAcActa(adjuntoId) {
  return axios.get(`${BASE}/actas/adjuntos/${adjuntoId}/archivo`, { responseType: "blob" });
}

// ============ Acta de investigacion (formulario de accidente) ============
// Las usan el admin y el portal del auditor externo por igual (mismas rutas, mismo backend).
// Las tres devuelven la respuesta axios COMPLETA, leer res.data. Las respuestas vienen en snake_case.

// Encabezado del formulario y datos de la empresa para precargar el acta nueva:
// { codigo, version, fecha_version, titulo, art_nombre, empresa_nombre }. Cualquiera
// puede venir en null (la empresa todavia no lo configuro).
export async function obtenerConfigInvestigacion({ signal } = {}) {
  return axios.get(`${BASE}/actas/investigacion/config`, { signal });
}

// Buscador del accidentado y de los testigos: hasta 20 empleados ACTIVOS de toda la
// empresa por nombre, apellido, prefijo de DNI o prefijo de legajo. Con menos de 2
// caracteres el backend devuelve [] (conviene no llamar). Cada item trae SOLO
// { employee_id, nombres, apellidos, legajo }.
export async function buscarEmpleadosInvestigacion(q, { signal } = {}) {
  return axios.get(`${BASE}/actas/investigacion/empleados`, {
    params: { q: (q || "").trim() },
    signal,
  });
}

// Datos del accidentado a la fecha del accidente (YYYY-MM-DD; sin fecha, hoy):
// { employee_id, nombres, apellidos, legajo, cargo, edad, antiguedad_cargo, encargado }.
// cargo, edad, antiguedad_cargo y encargado pueden venir en null. 404 si no existe.
export async function obtenerDatosAccidentado(employeeId, fecha, { signal } = {}) {
  return axios.get(`${BASE}/actas/investigacion/empleados/${encodeURIComponent(employeeId)}`, {
    params: fecha ? { fecha } : {},
    signal,
  });
}

// ============ Admin: Reportes (solo ADMIN y RRHH) ============

// params: periodo (MES | ANIO), anio y mes (mes solo con MES). Si faltan, el
// backend usa el mes/anio actual. Da 400 si son invalidos y 403 si el rol no es
// ADMIN ni RRHH.
// OJO: la senal va como SEGUNDO argumento posicional (no { signal }) porque asi
// la pasan useStats y usePagedList: fetcher(params, signal).
// Estilo admin: devuelven la respuesta axios completa, leer res.data.
export async function getAcReporteResumen(params = {}, signal) {
  return axios.get(`${BASE}/reportes/resumen`, { params, signal });
}

// Mismos params que el resumen mas page (base 0) y size. Devuelve un Page de
// Spring (content, totalElements, totalPages, number, size en camelCase) con cada
// item en snake_case: sesion_id, fecha_realizada, checklist_nombre, categoria,
// auditor_nombre, origen, objetivo_nombre, cliente_nombre, titulo.
export async function getAcReporteAuditorias(params = {}, signal) {
  return axios.get(`${BASE}/reportes/auditorias`, { params, signal });
}

// ---------------------------------------------------------------------------
// Etiqueta de un empleado presente para los selectores del modulo.
//
// El endpoint de empleados presentes devuelve el apellido como "lastname", todo
// junto: escribirlo "last_name" o "lastName" no rompe nada pero deja la etiqueta
// con el nombre solo, sin apellido. El legajo viene como "employee_number".
// ---------------------------------------------------------------------------
export function formatEmpleadoPresente(e) {
  if (!e) return "Empleado";
  const nombre = `${e.name || ""} ${e.lastname || ""}`.trim();
  const legajo = e.employee_number ?? e.employeeNumber;
  if (!nombre) return legajo ? `Legajo ${legajo}` : "Empleado";
  return legajo ? `${nombre} (Leg. ${legajo})` : nombre;
}
